/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type SimpleAnswer = typeof SimpleAnswer[keyof typeof SimpleAnswer];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SimpleAnswer = {
  Yes: 'Yes',
  No: 'No',
} as const;
